module.exports = __webpack_public_path__ + "img/ic_ycxd.fbec8519.png";